import { Link, LinkProps } from "@eworkit/iris";

import { downloaderBuilder } from "../downloadBuilder";

export const DownloadLink = downloaderBuilder<LinkProps>(Link);
